export var PartType;
(function (PartType) {
    PartType[PartType["INVENTORY"] = 1] = "INVENTORY";
    PartType[PartType["NON_INVENTORY"] = 2] = "NON_INVENTORY";
    PartType[PartType["SERVICE"] = 3] = "SERVICE";
    PartType[PartType["INTERNAL_USE"] = 4] = "INTERNAL_USE";
    PartType[PartType["CAPITAL_EQUIPMENT"] = 5] = "CAPITAL_EQUIPMENT";
    PartType[PartType["OVERHEAD"] = 6] = "OVERHEAD";
})(PartType || (PartType = {}));
//# sourceMappingURL=part-type.js.map